import $ from 'jquery'

/**
 * TODO: eval! usage through JQuery dataType: 'script' in silverfin/app/views/admin/account_entries/show.js.erb
 * Consider refactoring to an alternative rendering method
 * Why you should never use eval https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#never_use_eval!
 */
const getPage = (page, path) =>
  $.ajax({ type: 'GET', url: path, data: { page }, dataType: 'script' })

const getNextPage = (initialPage, options) => {
  const { maxPage, path, removeSpinnerLayer } = options
  const nextPage = initialPage + 1

  getPage(initialPage, path).then(function () {
    if (nextPage >= maxPage) {
      removeSpinnerLayer()

      // if there is an anchor, go to this anchor now:
      if (window.location.hash !== '') {
        // eslint-disable-next-line no-self-assign
        window.location = window.location
      }
    } else {
      getNextPage(nextPage, options)
    }
  })
}

onDomLoad(function ($dom) {
  const table = $dom[0].querySelector(
    "[data-behaviour~='load-async-account-entries']"
  )

  if (!table) {
    return
  }

  const maxPage = table.dataset.maxPage
  const path = table.dataset.accountEntriesPath

  const spinner = $dom[0].querySelector(
    "[data-behaviour~='load-account-entries-status']"
  )

  const removeSpinnerLayer = () => (spinner.innerHTML = '')

  if (maxPage < 2) {
    removeSpinnerLayer()
    return
  }

  const page = 2

  getNextPage(page, { maxPage, path, removeSpinnerLayer })
})
